import { createContext, useContext, useEffect, useState } from "react";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {

    const [selectedStoreId, setSelectedStoreId] = useState(() => {
        return localStorage.getItem("currentStoreId") || "";
    });

    useEffect(() => {
        if (selectedStoreId) {
            localStorage.setItem("currentStoreId", selectedStoreId);
        }
    }, [selectedStoreId]);

    return (
        <StoreContext.Provider
            value={{
                selectedStoreId,
                setSelectedStoreId,
            }}
        >
            {children}
        </StoreContext.Provider>
    );
};

// Custom hook
export const useStore = () => {
    const context = useContext(StoreContext);
    if (!context) {
        throw new Error("useStore must be used inside StoreProvider");
    }
    return context;
};
